import type { UserRole } from '../../services/authPermissions';

export interface UserFinancialPermissionDefaults {
  canManageOrderCosts: boolean;
  canManagePurchaseInvoices: boolean;
  canViewMargin: boolean;
}

export function getDefaultFinancialPermissionsForRole(
  role: UserRole | string | null | undefined
): UserFinancialPermissionDefaults {
  const enabledByDefault = role === 'ADMIN';

  return {
    canManageOrderCosts: enabledByDefault,
    canManagePurchaseInvoices: enabledByDefault,
    canViewMargin: enabledByDefault,
  };
}
